import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component';
import { ButtonTypeEnum, ButtonSizeEnum } from '../button/buttonTypesEnum';
import { FilterCriteria } from '@model/filter/filter-options.model';

/**
 * Active Filters Display Component
 * Shows currently applied filters as chips/badges with option to clear all
 */
@Component({
  selector: 'app-active-filters',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './active-filters.component.html'
})
export class ActiveFiltersComponent {
  @Input() filterCriteria: FilterCriteria | null = null;
  @Output() clearFilters = new EventEmitter<void>();

  readonly ButtonTypeEnum = ButtonTypeEnum;
  readonly ButtonSizeEnum = ButtonSizeEnum;

  private readonly priorityNames: Record<string, string> = {
    '1': 'Estándar',
    '2': 'Administrativa',
    '3': 'Institución',
    '4': 'Clínica',
    '5': 'Todas'
  };

  getPriorityName(priorityId: string): string {
    return this.priorityNames[priorityId] || priorityId;
  }

  onClearFilters(): void {
    this.clearFilters.emit();
  }
}
